import { QuestionCircleOutlined } from "@ant-design/icons";
import { SelectLang as UmiSelectLang } from "@umijs/max";

export type SiderTheme = "light" | "dark";

export const SelectLang: React.FC = () => {
  return (
    <UmiSelectLang
      style={{
        padding: 4,
      }}
    />
  );
};

export const Question: React.FC = () => {
  return (
    <a
      href="https://www.fm618.net/"
      target="_blank"
      rel="noreferrer"
      style={{
        display: "inline-flex",
        padding: "4px",
        fontSize: "18px",
        color: "inherit",
      }}
    >
      <QuestionCircleOutlined />
    </a>
  );
};
